import React, { forwardRef, useEffect, useState } from "react";

import { IInput } from "./input.d.ts";

import { Container, Error, InputDS, InputMaskDS, Label } from "./styles";

/**
 * Componente de input
 * @param {IInput} props - Props do componente
 * @returns {JSX.Element} Componente do input
 **/

const Input = forwardRef(
	/**
	 * Componente de input
	 * @param {IInput} props - Props do componente
	 * @returns {JSX.Element} Componente do input
	 **/

	({ label, errorMessage, mask, fieldRegister, disabled, register, ...rest }, ref) => {
		const [error, setError] = useState("");

		useEffect(() => {
			if (errorMessage !== undefined) {
				setError(
					typeof errorMessage === "string" ? errorMessage : errorMessage.message
				);
			} else {
				setError("");
			}
		}, [errorMessage]);

		return (
			<Container>
				<Label>{label}</Label>
				{mask && mask.length ? (
					<InputMaskDS
						{...rest}
						ref={ref}
						mask={mask}
						disabledInput={disabled}
						error={Boolean(error && error.length)}
					/>
				) : (
					<InputDS
						ref={ref}
						{...rest}
						{...register(fieldRegister)}
						disabledInput={disabled}
						error={Boolean(error && error.length)}
					/>
				)}
				{error && error.length && <Error>{error}</Error>}
			</Container>
		);
	}
);

Input.displayName = "Input";

export default Input;
